$(document).ready(function() {

  setTimeout(function() {
      $('.Index_hero_outer').addClass('loaded');
  }, 200);

  window.addEventListener('scroll', function() {
      var scrollDiv = $('.Index_compare_right_badge');
      if (scrollDiv.length) {
          var scrollRatio = ($(document).scrollTop() + $(window).height()) / $(document).height();
          var maxScrollWidth = 40; // maximum width of the div when fully scrolled

          scrollDiv.css('width', (scrollRatio * maxScrollWidth) + 'vw');
      }
  });


  // Vertical line drawing in features

  window.addEventListener('scroll', function() {
      var scrollDiv1 = $('.Index_features_line_vertical');
      var targetDiv = $('.Index_features_outer');
      var maxScrollHeight = $('.Index_features_inner').height() - 80; // maximum height based on .Index_features_inner

      if (scrollDiv1.length && targetDiv.length) {
          var targetOffset = targetDiv.offset().top;
          var scrollTop = $(document).scrollTop();
          var containerHeight = targetDiv.height();

          if (scrollTop < targetOffset + 250 && scrollTop + $(window).height() > targetOffset) {
              var scrollRatio1 = Math.max(0, scrollTop + $(window).height() - targetOffset - 250) / containerHeight;
              var scrollHeight = Math.min(scrollRatio1 * maxScrollHeight, maxScrollHeight);

              scrollDiv1.css('height', scrollHeight + 'px');
          }
      }
  });

  
  var functionExecuted1 = false;
  var functionExecuted2 = false;
  var functionExecuted3 = false;
  var functionExecuted4 = false;

     $(window).scroll(function() {
        var targetDiv1 = $('.ScrollTrigger_1');
        var targetDiv2 = $('.ScrollTrigger_2');
        var targetDiv3 = $('.ScrollTrigger_3');
        var targetDiv4 = $('.ScrollTrigger_4');
    
        // Calculate the position of each target div relative to the viewport
        var targetOffset1 = targetDiv1.offset().top;
        var targetHeight1 = targetDiv1.outerHeight();
    
        var targetOffset2 = targetDiv2.offset().top;
        var targetHeight2 = targetDiv2.outerHeight();
    
        var targetOffset3 = targetDiv3.offset().top;
        var targetHeight3 = targetDiv3.outerHeight();
    
        var targetOffset4 = targetDiv4.offset().top;
        var targetHeight4 = targetDiv4.outerHeight();
    
        var windowHeight = $(window).height();
        var windowScroll = $(this).scrollTop();
    
        // Check if each target div is in the viewport and the respective function hasn't been executed yet
        if (windowScroll > targetOffset1 - windowHeight + targetHeight1 && !functionExecuted1) {
            // Target div 1 is visible in the viewport and its function hasn't been executed
            $('.ScrollTrigger_1').addClass('loaded');
            functionExecuted1 = true;
        }
    
        if (windowScroll > targetOffset2 - windowHeight + targetHeight2 && !functionExecuted2) {
            // Target div 2 is visible in the viewport and its function hasn't been executed
            $('.ScrollTrigger_2').addClass('loaded');
            functionExecuted2 = true;
        }
    
        if (windowScroll > targetOffset3 - windowHeight + targetHeight3 && !functionExecuted3) {
            // Target div 3 is visible in the viewport and its function hasn't been executed
            $('.ScrollTrigger_3').addClass('loaded');
            functionExecuted3 = true;
        }
    
        if (windowScroll > targetOffset4 - windowHeight + targetHeight4 && !functionExecuted4) {
            // Target div 4 is visible in the viewport and its function hasn't been executed
            $('.ScrollTrigger_4').addClass('loaded');
            functionExecuted4 = true;
        }
    }); 
  

  $('.Index_statistics_carousel__js').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true
  });


  $('.Homepage_features_carousel_container').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
  });
});